<script>
  import { getContext } from 'svelte';
  export let message;
  export let title;
  export let hasCancel = false;

  export let dialog_type = "error"
	
	export let onCancel = () => {};
	export let onOkay = () => {};

  	const { close } = getContext('simple-modal');
	
	let value;
	let onChange = () => {};
	
	function _onCancel() {
		onCancel();
		close();
	}
	
	function _onOkay() {
		onOkay(value);
		close();
	}
	
	$: onChange(value)
</script>

<style>
  h2 {
		font-size: 2rem;
		text-align: center;
	}

	
	.buttons {
		border-top: 1px solid #eee;
		padding-top: 1em;
		display: flex;
		justify-content: center;

		
	}

	button {
		background: none;
		font-weight: 500;
		border: none;
		display: block;
		flex: 1 1 100%;
	}

</style>

<h2>{title}</h2>
{#if message}
	<p>{ message }</p>
{/if}

<div class="buttons">
{	#if hasCancel }
		<button class="cancel" on:click={_onCancel}>
			Cancel
		</button>
	{/if}
	<button class="ok" on:click={_onOkay}>
		Okay
	</button>
</div>